<div class="discount-rejection-coupon-example" [ngClass]="{ 'is-mobile': isMobile }">
  <!-- Order summary skeleton -->
  <div class="checkout-skeleton">
    <div class="checkout-skeleton__product">
      <div class="checkout-skeleton__product-image">
        <img src="assets/icons/checkout_content_default.png" alt="" />
        <span class="checkout-skeleton__badge">1</span>
      </div>
      <div class="checkout-skeleton__product-details">
        <div class="checkout-skeleton__line checkout-skeleton__line--long"></div>
        <div class="checkout-skeleton__line checkout-skeleton__line--short"></div>
      </div>
      <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
    </div>

    <div class="checkout-skeleton__divider"></div>

    <!-- Discount code input skeleton -->
    <div class="checkout-skeleton__discount-row">
      <div class="checkout-skeleton__discount-input"></div>
      <div class="checkout-skeleton__discount-button"></div>
    </div>
  </div>

  <!-- Discount rejection widget -->
  @if (activeConfiguration) {
    @if (widgetType === WidgetType.BANNER) {
      <div class="drce-banner" [attr.data-bg]="backgroundColor" [attr.data-text-color]="textColor">
        <div class="drce-icon">
          <pdq-icon [icon]="bannerIcon"></pdq-icon>
        </div>
        <div class="drce-content">
          <ng-container *ngTemplateOutlet="widgetContent"></ng-container>
        </div>
      </div>
    } @else if (widgetType === WidgetType.CLICKABLE) {
      <div class="drce-clickable" [attr.data-bg]="backgroundColor" [attr.data-text-color]="textColor">
        <div class="drce-clickable__message">
          <div class="drce-icon">
            <pdq-icon [icon]="bannerIcon"></pdq-icon>
          </div>
          <div class="drce-content">
            <ng-container *ngTemplateOutlet="widgetContent"></ng-container>
          </div>
        </div>
      </div>
      <button class="drce-clickable__button" [attr.data-btn-bg]="buttonAppearance">
        {{ buttonCtaText }}
      </button>
    }
  }

  <ng-template #widgetContent>
    @if (messageTitle) {
      <span class="drce-title" [innerHTML]="messageTitle"></span>
      @if (messageDescription) {
        <p class="drce-description" [innerHTML]="messageDescription"></p>
      }
    } @else if (messageDescription) {
      <p class="drce-description" [innerHTML]="messageDescription"></p>
    }
  </ng-template>

  <!-- Totals skeleton -->
  <div class="checkout-skeleton">
    <div class="checkout-skeleton__totals">
      <div class="checkout-skeleton__totals-row">
        <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
        <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
      </div>
      <div class="checkout-skeleton__totals-row">
        <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
        <div class="checkout-skeleton__line checkout-skeleton__line--price"></div>
      </div>
      <div class="checkout-skeleton__divider"></div>
      <div class="checkout-skeleton__totals-row">
        <div class="checkout-skeleton__line checkout-skeleton__line--medium"></div>
        <div class="checkout-skeleton__line checkout-skeleton__line--price-bold"></div>
      </div>
    </div>
  </div>
</div>
